import { CollectionModelType } from '@teinor/erp/types/company/product/collection'
import { dictionaryComplexFromJsonArr } from '../../globals/dictionary'
export interface CollectionsAction {
    type: 'CHANGE_COLLECTIONS'
    payload: CollectionsPayload
}
export type CollectionsPayload = CollectionModelType[]
export type CollectionJson = { [isoCode: string]: CollectionModelType } | null
export default function collections(state: CollectionJson = null, action: CollectionsAction): CollectionJson {
    switch (action.type) {
        case 'CHANGE_COLLECTIONS':
            return state = dictionaryComplexFromJsonArr(action.payload)
        default:
            return state
    }
}